const Tables = {
    tenants: { name: 'tenants', fields: 'id' },
    userInfo: { name: 'userInfo', fields: 'userName' },
    media: { name: 'media', fields: 'id, inspectionId' },
};

export default Tables;